import { posthog } from 'posthog-js';
import { FeatureFlag } from '~/app/enums/FeatureFlag';
import { TRACKER_DRIVER } from '~/app/enums/TrackerDriver';
import { FeatureFlagService } from '~/services/featureFlag/FeatureFlagService';
import { MockFeatureFlagService } from '~/services/featureFlag/MockFeatureFlagService';
import { PosthogFeatureFlagService } from '~/services/featureFlag/PosthogFeatureFlagService';

export default function useFeatureFlag(): FeatureFlagService {
    const {
        public: { trackerDriver },
    } = useRuntimeConfig();
    const isPostHogEnabled = trackerDriver === TRACKER_DRIVER.POSTHOG || trackerDriver === TRACKER_DRIVER.STACK;
    const service = isPostHogEnabled ? new PosthogFeatureFlagService(posthog) : new MockFeatureFlagService();

    return {
        isEnabled: (featureFlag: FeatureFlag, defaultValue?: boolean) => service.isEnabled(featureFlag, defaultValue),
        isDisabled: (featureFlag: FeatureFlag, defaultValue?: boolean) => service.isDisabled(featureFlag, defaultValue),
        getVariant: (featureFlag: FeatureFlag, defaultValue?: string) => service.getVariant(featureFlag, defaultValue),
        onFlagsResolved: (callback: () => void) => service.onFlagsResolved(callback),
    };
}
